type MatchVariantFn = (
  name: string,
  cb: (value: string, extra: { modifier: string | null }) => string | string[],
) => void;

const partVariant = (value: string): string => `&::part(${value})`;

const registerPartVariant = ({ matchVariant }: { matchVariant: MatchVariantFn }): void => {
  matchVariant("part", partVariant);
};

export const TailwindCssPluginPart = () => registerPartVariant;

/** Default export for use with Tailwind v4's `@plugin` CSS directive. */
export default TailwindCssPluginPart();
